<template>
  <a-modal :title="formTitle" width="45%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-form-model ref="form" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item label="名称" prop="name" >
        <a-input v-model="form.ruleName" :maxLength="50" placeholder="请输入名称" />
      </a-form-model-item>
      <a-form-model-item label="开始时间" prop="startTime" >
        <a-date-picker style="width: 100%" v-model="form.startTime" :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}" format="YYYY-MM-DD HH:mm:ss" valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <a-form-model-item label="结束时间" prop="endTime" >
        <a-date-picker style="width: 100%" v-model="form.endTime" :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}" format="YYYY-MM-DD HH:mm:ss" valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>

      <a-form-model-item class="text item" label="规则" >
        <span>每满&nbsp;</span>
        <a-input  v-model="form.amountStep" @change="limitAmountStep"
                         style="width: 160px" :max="100"  controls-position="right">
        </a-input>
        <span>元,&nbsp;</span>
        <span>可抵扣&nbsp;</span>
        <a-input  v-model="form.amount" @change="limitAmount" style="width: 160px" :max="10"  controls-position="right"></a-input>
        <span>元,&nbsp;</span>
        <span>需要消耗&nbsp;</span>
        <a-input-number v-model="form.score"
                          style="width: 160px" :max="1000"  controls-position="right">
        </a-input-number>积分
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入备注" type="textarea" allow-clear />
      </a-form-model-item>

    </a-form-model>
    <div slot="footer" class="dialog-footer">
      <a-button type="primary" @click="submitForm">确 定</a-button>
      <a-button @click="cancel">取 消</a-button>
    </div>
  </a-modal>
</template>

<script>
import { getUserScoreTimeRule, addUserScoreTimeRule, updateUserScoreTimeRule } from '@/api/user/ruleTime'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import moment from 'moment';

export default {
  name: 'LabelModal',
  props: {
  },
  components: {
    CustomDictTag,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      // 表单参数
      form: {
        ruleName: null,
        year: null,
        amount :1,
        type:1,
        amountStep:10,
        score:100,
        rate: 1,
        startTime: null,
        endTime: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        ruleName: [
          { required: true, message:'名称不能为空', trigger: 'blur' }
        ],
        year: [
          { required: true, message:'年份不能为空', trigger: 'blur' }
        ],
        startTime: [
          { required: true, message: '开始时间不能为空', trigger: 'change' }
        ],
        endTime: [
          { required: true, message: '结束时间不能为空', trigger: 'change' }
        ],
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    moment,
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    previewVideoCancel() {
      this.previewVideoVisible = false;
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        ruleName: null,
        year: null,
        amount :1,
        amountStep:10,
        type:1,
        score:100,
        rate: 1,
        startTime: null,
        endTime: null,
      }

    },

    handleRemove() {
      this.form.icon = ''
    },

    limitAmount() {
      // console.log(i);
      let val = this.form.amount.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/, '$1');
      if (val == null || val == undefined || val == '' || val<1) {
        val = 1
      }
      if (val > 21474836) {
        val = 21474836
      }
      this.form.amount = val
    },

    limitAmountStep() {
      // console.log(i);
      let val = this.form.amountStep.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/, '$1');
      if (val == null || val == undefined || val == '' || val<1) {
        val = 1
      }
      if (val > 21474836) {
        val = 21474836
      }
      this.form.amountStep = val
    },

    limitScore() {
      // console.log(i);
      let val = this.form.score.replace(/^\D*([0-9]\d*)?.*$/, '$1');
      if (val == null || val == undefined || val == '' || val<=0) {
        val = 1
      }
      if (val > 21474836) {
        val = 21474836
      }
      this.form.score = val
    },

    limitRate() {
      // console.log(i);
      let val = this.form.rate.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/, '$1');
      if (val == null || val == undefined || val == '' || val<0) {
        val = 0
      }
      if (val > 21474836) {
        val = 21474836
      }
      this.form.rate = val
    },



    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getUserScoreTimeRule({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateUserScoreTimeRule(this.form).then(response => {
              this.$message.success('修改成功')
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addUserScoreTimeRule(this.form).then(response => {
              this.$message.success('新增成功')
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
